module.exports = __webpack_public_path__ + "static/media/aoshstudio.77fdec56.png";